import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loading = false;
  private forceLoading = false;
  amount = 0;
  timeoutHandler: number | undefined | null | any;
  delayHandler: number | undefined | null | any;
  parentThis = this;
  canDisplay = false;

  setCustomTimeout() {
    // this.loading = this.canDisplay;
    this.timeoutHandler = setInterval(
      (parentRoot: any) => {
        if (parentRoot[0].amount <= 0) {
          parentRoot[0].setLoading(false);
          parentRoot[0].amount = 0;
          parentRoot[0].canDisplay = false;
          parentRoot[0].clearDelay();
          clearInterval(parentRoot[0].timeoutHandler);
        } else {
          parentRoot[0].canDisplay && parentRoot[0].setLoading(true);
          parentRoot[0].amount -= 1;
        }
      },
      250,
      [this.parentThis]
    );
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  getLoading(): boolean {
    return this.loading;
  }

  setForceLoading(force: boolean) {
    this.forceLoading = force;
    this.loading = force;

    document.getElementById('forcespinner')?.classList.remove('display-block');
    if (this.loading) {
      document.getElementById('forcespinner')?.classList.add('display-block');
    }
  }

  startDelay() {
    if (!this.delayHandler) {
      this.delayHandler = setTimeout(() => {
        // this.canDisplay = this.amount > 2;
        this.canDisplay = this.amount > 0;
        this.setLoading(this.canDisplay);
        this.delayHandler = undefined;
      }, 200);
    }
  }

  clearDelay() {
    clearTimeout(this.delayHandler);
    this.canDisplay = false;
    this.delayHandler = undefined;
  }

  startLoadingSpinner() {
    if (this.forceLoading) return;
    if (!this.canDisplay) this.startDelay();
    if (this.timeoutHandler) clearInterval(this.timeoutHandler);
    this.amount = this.amount + 1;
    this.setCustomTimeout();
  }

  stopLoadingSpinner() {
    if (this.forceLoading) return;
    if (this.timeoutHandler) clearInterval(this.timeoutHandler);
    this.amount = this.amount - 1 || 0;
    if (this.amount === 0) {
      this.clearDelay();
    }
    //   this.canDisplay = false;
    //   this.setLoading(false);
    //   clearInterval(this.timeoutHandler);
    // }
    this.setCustomTimeout();
  }
}
